import React, { useState, ChangeEvent, FC, useEffect } from 'react';

interface UnderVoltageProps {
  alarm: any;
  onChange: (newMetrics: any) => void;
}

const UnderVoltage: FC<UnderVoltageProps> = ({ alarm, onChange }) => {
  const [voltageThreshold, setVoltageThreshold] = useState<number>(0);

  useEffect(() => {
    if (alarm !== "") {
      setVoltageThreshold(alarm.undervoltage_threshold);
    } else {
      setVoltageThreshold(0);
    }
  }, [alarm]);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(event.target.value);
    setVoltageThreshold(value);
    onChange({ type: "UnderVoltage", undervoltage_threshold: value });
  };

  return (
    <div className="input-group col-md-4 col-sm-4">
      <input
        className="form-control input-sm"
        name="under_voltage"
        min={0}
        value={voltageThreshold}
        placeholder="Voltage Threshold (e.g. 11.5)"
        type="number"
        step="0.1"
        size={10}
        maxLength={20}
        onChange={handleInputChange}
      />
      <span style={{ paddingLeft: 10 }} className="input-group-addon">V</span>
    </div>
  );
};

export default UnderVoltage;
